import React, {PureComponent} from 'react';

import Input from '../Input';
import * as csvValidator from './validators/csvValidator';
import * as txtValidator from './validators/txtValidator';
import * as pngValidator from './validators/pngValidator';
import * as jpgValidator from './validators/jpgValidator';
import * as svgValidator from './validators/svgValidator';
import * as gifValidator from './validators/gifValidator';

const validators = {
  csv: {...csvValidator},
  txt: {...txtValidator},
  png: {...pngValidator},
  gif: {...gifValidator},
  jpg: {...jpgValidator},
  svg: {...svgValidator}
}

const physicalLimit = 2000000000

class FileUpload extends PureComponent {
  state = {
    rejected: false,
    validationText: "",
    maxBytes: physicalLimit
  }

  componentDidMount() {
    const {allowedTypes=[], maxKB, maxMB, maxGB} = this.props;
    const missedTypes = allowedTypes.filter(type => Object.keys(validators).indexOf(type) < 0);

    if (allowedTypes.length === 0) {
      throw new Error("No Types defined");
    }

    if (missedTypes.length > 0) {
      throw new Error("No Validator found for " + missedTypes.join(", "));
    }

    let maxBytes = physicalLimit;
    if (maxKB) {
      maxBytes = maxKB * 1000;
    }
    else if (maxMB) {
      maxBytes = maxMB * 1000000;
    }
    else if (maxGB) {
      maxBytes = maxGB * 1000000000;
    }

    if (maxBytes > physicalLimit) {
      throw new Error("Physical limit breached");
    }
    
    this.setState({validationText: this.buildValiationText(allowedTypes), maxBytes});
  }

  buildValiationText(types) {
    const {maxKB, maxMB, maxGB} = this.props;
    let sizeString = "2GB";
    if (maxKB) {
      sizeString = maxKB + "KB";
    }
    else if (maxMB) {
      sizeString = maxMB + "MB";
    }
    else if (maxGB) {
      sizeString = maxGB + "GB";
    }

    if (types.length === 1) {
      return "Only " + types[0].toUpperCase() + " format is Accepted. The maximum allowed size is " + sizeString + "."
    }
    const typeString = types.join(", ").toUpperCase().replace(/,(?=[^,]*$)/, " and");
    return "Accepted formats are: " + typeString + ". The maximum allowed size is " + sizeString + ".";
  }

  addFiles = (event) => {
    const {onFilesAdd, allowedTypes = []} = this.props
    const {maxBytes} = this.state;
    //make sure all files are of the allowed type
    const files = Object.keys(event.target.files).map(key => ({file: event.target.files[key], type: ""}));
    const rejectedKeys = [];
    for (let i = 0; i < files.length; i++) {
      if (files[i].file.size > maxBytes) {
        rejectedKeys.push(i);
        continue;
      }
      //pass through validators for each allowed types
      for (let j = 0; j < allowedTypes.length; j++) {
        if (validators[allowedTypes[j]].validate(files[i].file)) {
          files[i].type = validators[allowedTypes[j]].getUploadMimeType();
          break;
        }
      }
      if (files[i].type === "") {
        rejectedKeys.push(i);
      }
    }

    if (rejectedKeys.length !== 0) {
      this.setState({rejected: true});
    }
    else {
      this.setState({rejected: false});
      onFilesAdd(files);
    }
  }
  
  render() {
    const {allowedTypes, onFilesAdd, maxKB, maxMB, maxGB, ...otherProps} = this.props;
    const {rejected, validationText} = this.state

    return (
      <Input 
        type="file" 
        onChange={(event) => this.addFiles(event)} invalid={rejected} 
        validationText={validationText} 
        helpText={validationText}
        {...otherProps}/>
    );
  }
}

export default FileUpload;